module.exports = __webpack_public_path__ + "static/img/RoomSetting.2c7f3852.png";